// extracted by mini-css-extract-plugin
export default {"ratingsContainer":"Rating_ratingsContainer__Fxx1i","rating":"Rating_rating__gTYwS"};